/* eslint-disable */
import './style.scss'
import React, { useEffect, useReducer, useState, useRef, useMemo, useContext, useCallback } from 'react'
import { useHistory } from 'react-router-dom'
import Marquee from 'react-fast-marquee'
import { Toast } from 'primereact/toast'
import { useTranslation } from 'react-i18next'
import { useErrorBoundary } from 'react-error-boundary'
import { updateUserDetails, getLocalUserDetails, getLocalLoggedInStatus, setLocalWithLatestNewsReadNotification, getLocalTheme } from 'Utils/LocalStorage_Handler'
import TimerPicker from 'Components/TimerPicker'
import { RouteStrings } from 'Utils/Routes/RouteStrings'
import { onSnapshot, doc } from 'firebase/firestore'
import { db } from 'firebase.js'
import { getAllFreeTrendingNewsForGuest, getAllShortNewsForSubForCountry, getICEMartketTerminalDataFromHttpURL } from 'Services/apiAdapter_CoffeeWeb'
import { subscribeToPersonalChatRealtime, subscribeToCommunityChatRealtime } from 'Services/chatRealtimeSubscriptions'
import { ROUTE_STRINGS, COFFEEQUOTES_STATIC_VALUES } from 'Utils/Constants'
import AccordianData from './Components/AccordianData'
import AccordianForMobile from './Components/AccordianForMobile'
import AccordianPopUp from './Components/AccordianPopup'
import { useResizeHandler768, commonMethods } from 'Utils/commonMethods'
import ErrorMessageModal from 'Components/UIComponent/ConfirmationModal'
import CreateAccountInfoModal from 'Components/UIComponent/CreateAccountInfoModal'
import { coffeeQuotesDefaultValue } from 'Utils/coffeeQuotesDummyData'
import { CoffeeWebContext } from 'Context/CoffeeWebContext'
import WorkBook from './Components/WorkBook'
import MetaTagsComponent from 'Components/MetaTagsComponent'
import useAnalytics from 'Utils/useAnalytics'
import { SCREEN_EVENTS, USER_EVENTS } from 'Utils/Constants/analyticsEvents'
import CoffeeChats from './Components/CoffeeChats'
import DraggableChatButton from './Components/DraggableChatButton'

const CoffeeQuotes = ({ showError, showSuccess, showConfirmation, coffeeQuotesMockFlag, coffeeQuotesMockApiFlag }) => {
  const userDetails = getLocalUserDetails()
  const userLoginStatus = getLocalLoggedInStatus()
  const { trackEvent, setScreenLog } = useAnalytics()

  const { id: userId, countryId, isCoffeeQuotesAvailable: isTincapheUser, isWorkBookAvailable } = userDetails || {}
  const isIndianUser = userDetails?.countryId === 102 || userDetails?.userCountryDetails?.nicename === 'India'

  const { isMarketLive, getButtonAndInfo, dateFormatBasedOnUser } = commonMethods
  const { websocketReconnectionInterval, socketHealthCheckInterval, handleWorkbookDropDown } = COFFEEQUOTES_STATIC_VALUES

  const { isWebView, isMobileView } = useResizeHandler768()
  const params = new URLSearchParams()
  const { setLoading } = useContext(CoffeeWebContext)
  const isPlatinumUser = userDetails?.sub?.subType === 3
  const { showBoundary } = useErrorBoundary()
  const { t } = useTranslation()
  const history = useHistory()

  const initialState = {
    robustaData: coffeeQuotesDefaultValue,
    arabicaData: coffeeQuotesDefaultValue,
    workbookRobustaData: null,
    workbookArabicaData: null,
    selectedCurrencyRobusta: 0,
    selectedCurrencyArabica: 0,
    fxCurrencyList: null,
    accordianPopUp: false,
    lastUpdatedTimingForCoffeequotes: Date.now()
  }

  const reducer = (state, action) => {
    return { ...state, ...action.payload }
  }

  const [state, dispatch] = useReducer(reducer, initialState)

  const workBookComponentRef = useRef(null)
  const robustaRef = useRef(state.robustaData)
  const arabicaRef = useRef(state.arabicaData)
  const volumeDataRef = useRef(null)
  const certifiedLotsDataRef = useRef(null)
  const workbookRobustaDataRef = useRef(state.workbookRobustaData)
  const workbookArabicaDataRef = useRef(state.workbookArabicaData)
  const selectedCurrencyRobustaRef = useRef(state.selectedCurrencyRobusta)
  const selectedCurrencyArabicaRef = useRef(state.selectedCurrencyArabica)
  const fxCurrencyListRef = useRef(state.fxCurrencyList)
  const accordianPopUpRef = useRef(state.accordianPopUp)
  const lastMessageReceivedAtRef = useRef(state.lastMessageReceivedAt)
  const coffeequoteDataErrorToast = useRef(null)

  const [marquee, setMarquee] = useState([])
  const [selectedContract, setSelectedContract] = useState({})
  const [searchContractList, setSearchContractList] = useState([])
  const [searchContractListForRobusta, setSearchContractListForRobusta] = useState([])
  const [searchContractListForArabica, setSearchContractListForArabica] = useState([])
  const [accordianPopupData, setAccordianPopupData] = useState(null)
  const [accordianPopupListData, setAccordianPopupListData] = useState([])
  const [handleSelectedTerminal, setHandleSelectedTerminal] = useState({})
  const [seletectedWorkBookType, setSelectedWorkBookType] = useState(handleWorkbookDropDown[0].value)
  const [trendingNewsStyle, setTrendingNewsStyle] = useState({ width: '100%' })
  const [isChatPanelOpen, setIsChatPanelOpen] = useState(false)
  const [personalUnreadCount, setPersonalUnreadCount] = useState(0)
  const [communityUnreadCount, setCommunityUnreadCount] = useState(0)

  const handleUnreadCountsChange = useCallback(({ personal, community }) => {
    setPersonalUnreadCount(personal)
    setCommunityUnreadCount(community)
  }, [])

  const unreadCountRefreshRef = useRef(null)

  useEffect(() => {
    const navbar = document.querySelector('.navbar-nav')

    if (!navbar) return

    const updatePosition = () => {
      const rect = navbar.getBoundingClientRect()
      // 200px total horizontal space (100px left + 100px right)
      const widthWithPadding = Math.max(0, rect.width - 224)
      setTrendingNewsStyle({
        width: `${widthWithPadding}px`
      })
    }

    updatePosition()

    // Observe navbar changes
    const observer = new ResizeObserver(() => updatePosition())
    observer.observe(navbar)

    // Handle browser resizes
    window.addEventListener('resize', updatePosition)

    return () => {
      observer.disconnect()
      window.removeEventListener('resize', updatePosition)
    }
  }, [])

  useEffect(() => {
    const firebaseCleanUpMethod = firebaseSnapshotForTrendingNews()
    const websocketCleanUpMethod = handleWebSocket()

    setScreenLog(SCREEN_EVENTS.COFFEE_QUOTES_SCREEN)
    getTrendingNews()
    if (userDetails) {
      updateUser()
    }

    return () => {
      firebaseCleanUpMethod()
      websocketCleanUpMethod()
      setLoading(false)
    }
  }, [])

  useEffect(() => {
    if (accordianPopUpRef?.current) {
      calculateTerminalDifference()
    }
  }, [state])

  // useEffect to initialize state for testing purposes
  useEffect(() => {
    if (coffeeQuotesMockFlag) {
      setAccordianPopupData(coffeeQuotesMockFlag?.mockDataForAccordianPopUp)
      setMarquee(coffeeQuotesMockFlag.mockDataForTrendingNews)

      accordianPopUpRef.current = true
      robustaRef.current = coffeeQuotesMockFlag?.mockDataForRobusta
      arabicaRef.current = coffeeQuotesMockFlag?.mockDataForArabica
      lastMessageReceivedAtRef.current = Date.now()
      dispatch({ payload: { accordianPopUp: true, robustaData: coffeeQuotesMockFlag?.mockDataForRobusta, arabicaData: coffeeQuotesMockFlag?.mockDataForArabica, lastMessageReceivedAt: Date.now() } })
    } else if (coffeeQuotesMockApiFlag) {
      getICEDataCoffeeQuotesDataFromHttpURL()
      connectToWebSocket()
    }
  }, [])

  const firebaseSnapshotForTrendingNews = () => {
    let cleanUp = () => {}

    let mounted = false

    if (userDetails?.phone || userDetails?.email || userLoginStatus === false) {
      const unSub = onSnapshot(doc(db, process.env.REACT_APP_ENVIRONMENT === 'develop' ? 'CoffeeWeb_Devp' : 'CoffeeWeb', 'NewsFeeds'), (doc) => {
        if (mounted) {
          const firebaseResponse = doc.data()
          const subscriptionList = firebaseResponse?.LatestNewsForSubscription?.split(',')?.map((ele) => parseInt(ele.trim(), 10))
          const countryList = firebaseResponse?.LatestNewsForCountries?.split(',')?.map((ele) => parseInt(ele.trim(), 10))
          if ((subscriptionList?.includes(userDetails?.sub?.subType) && countryList.includes(countryId) && !firebaseResponse?.IsDeleted && firebaseResponse?.IsApproved) || firebaseResponse.IsFreeNews) {
            getTrendingNews()
          }
        } else {
          mounted = true
        }
      })

      return () => {
        unSub()
      }
    }

    return cleanUp
  }

  const getTrendingNews = async () => {
    try {
      let response

      if (!userDetails) {
        response = await getAllFreeTrendingNewsForGuest()
      } else {
        response = await getAllShortNewsForSubForCountry(userId)
      }

      setMarquee(response.data?.returnLst || [])
    } catch (error) {
      console.error(error)
    }
  }

  const updateUser = async () => {
    const response = await updateUserDetails()

    if (response?.status === 401) {
      showBoundary('unAuthorized')
    }
  }

  const handleWebSocket = () => {
    const { isMarketActive } = isMarketLive()
    let cleanUpWebSocket
    let isComponentUnmounted = false

    if (isTincapheUser) {
      cleanUpWebSocket = connectToWebSocket()
    } else if (isMarketActive) {
      ;(async () => {
        await getICEDataCoffeeQuotesDataFromHttpURL()
        if (!isComponentUnmounted) {
          cleanUpWebSocket = connectToWebSocket()
        }
      })()
    } else {
      getICEDataCoffeeQuotesDataFromHttpURL()
    }

    const checkForSocketHealth = setInterval(() => {
      const elapsedTime = Date.now() - lastMessageReceivedAtRef?.current
      const { isMarketActive } = isMarketLive()
      if (elapsedTime > 15000 && isMarketActive) {
        if (cleanUpWebSocket) {
          cleanUpWebSocket()
          lastMessageReceivedAtRef.current = Date.now()
          dispatch({ payload: { lastMessageReceivedAt: Date.now() } })
        }
        cleanUpWebSocket = connectToWebSocket('connect it again')
      }
    }, socketHealthCheckInterval) // 2000ms

    const reconnectSockectEvery5min = setInterval(() => {
      const { isMarketActive } = isMarketLive()

      if (cleanUpWebSocket) {
        cleanUpWebSocket()
      }
      if (isMarketActive) {
        cleanUpWebSocket = connectToWebSocket('refresh')
      }
    }, websocketReconnectionInterval) // 5min

    return () => {
      isComponentUnmounted = true
      clearInterval(reconnectSockectEvery5min)
      clearInterval(checkForSocketHealth)
      if (cleanUpWebSocket) {
        cleanUpWebSocket()
      }
    }
  }

  const connectToWebSocket = (status) => {
    const { isMarketActive } = isMarketLive()
    const socketUrl = isTincapheUser ? `${process.env.REACT_APP_BASE_WEBSOCKET_FOR_COFFEE_QUOTES}/api/GetAllTincapcheDataDetail` : `${process.env.REACT_APP_BASE_PROD_WEBSOCKET_FOR_COFFEE_QUOTES}/api/GetICEMartketTerminalData`
    const socket = new WebSocket(socketUrl)

    let coffeeqotesData
    let resetFlickeringTimer

    if (robustaRef.current[0].optionExpiry === 'DD-MMM-YYYY') {
      setLoading(true)
    }

    if (!isMarketActive) {
      setTimeout(() => socket.close(), 1 * 60 * 1000)
    }

    socket.onmessage = (event) => {
      if (robustaRef.current[0].optionExpiry === 'DD-MMM-YYYY') {
        setLoading(false)
      }
      clearTimeout(resetFlickeringTimer)
      resetFlickeringTimer = setTimeout(() => {
        resetFlickeringEffect()
      }, 1500)

      const parsedData = JSON.parse(event.data)

      const volumeData = parsedData?.ReturnLst?.volumeData
      volumeDataRef.current = volumeData

      const certifiedLotsData = parsedData?.ReturnLst?.certified_Lots
      certifiedLotsDataRef.current = certifiedLotsData

      if (isTincapheUser) {
        coffeeqotesData = parsedData?.ReturnLst?.CoffeeQuotesTincapcheData
      } else {
        const updatedRows = parsedData?.ReturnLst?.CoffeeQuotesICEData || []
        const existingData = [...(robustaRef.current || []), ...(arabicaRef.current || [])]
        const existingRowsByKey = new Map(existingData.map((item) => [`${item?.idMarket}-${item?.contractName}`, item]))

        updatedRows.forEach((row) => {
          const key = `${row?.idMarket}-${row?.contractName}`
          const previousRow = existingRowsByKey.get(key) || {}
          existingRowsByKey.set(key, { ...previousRow, ...row })
        })

        coffeeqotesData = Array.from(existingRowsByKey.values())
      }

      const currencyList = parsedData?.ReturnLst?.CoffeequotescurrencyData

      handleFilterCoffeeQuotesData(coffeeqotesData, currencyList)
    }

    socket.onclose = function () {
      // console.log('WebSocket connection closed here')
    }

    function closeConnection() {
      socket.close()
    }

    return closeConnection
  }

  const getICEDataCoffeeQuotesDataFromHttpURL = async () => {
    setLoading(true)
    const response = await getICEMartketTerminalDataFromHttpURL()

    try {
      const { statusCode, returnLst } = response.data

      if (statusCode === 200) {
        const coffeeqotesData = returnLst?.coffeeQuotesICEData
        const currencyList = returnLst?.coffeequotescurrencyData
        const volumeData = returnLst?.volumeData

        volumeDataRef.current = volumeData

        const certifiedLotsData = returnLst?.certified_Lots
        certifiedLotsDataRef.current = certifiedLotsData

        handleFilterCoffeeQuotesData(coffeeqotesData, currencyList)
      }
    } catch {
      coffeequoteDataErrorToast.current.show({ severity: 'error', summary: t('ERROR'), detail: t('FAILED_TO_GET_DATA') })
    } finally {
      setLoading(false)
    }
  }

  const handleFilterCoffeeQuotesData = (coffeeqotesData, currencyList) => {
    if (coffeeqotesData?.length > 0) {
      const robustaAndArabicaArray = coffeeqotesData
      const robustaFilteredData = robustaAndArabicaArray?.filter((item) => item.idMarket === 1)
      const arabicaFilteredData = robustaAndArabicaArray?.filter((item) => item.idMarket === 2)

      robustaAndArabicaArray.forEach((item) => {
        item.optionExpiryDateFormat = dateFormatBasedOnUser(item.optionExpiryDateFormat)
        item.firstNoticeDateFormat = dateFormatBasedOnUser(item.firstNoticeDateFormat)
      })

      const updateHighlightStatus = (currentPrices, previousDataSet) => {
        const previousDataByKey = new Map((previousDataSet || []).map((item) => [`${item?.idMarket}-${item?.contractName}`, item]))

        return currentPrices.map((item) => {
          const previousItem = previousDataByKey.get(`${item?.idMarket}-${item?.contractName}`)
          const hasPreviousData = previousItem?.lastChng !== undefined

          const isPriceChanged = item?.chng !== previousItem?.chng
          const isBidChanged = item?.bid !== previousItem?.bid

          const shouldHighlight = hasPreviousData && (isPriceChanged || (!isTincapheUser && isBidChanged))
          return {
            ...item,
            isHighlightRow: shouldHighlight ? 'highlight_color' : ''
          }
        })
      }

      const robustaData = updateHighlightStatus(robustaFilteredData, robustaRef?.current)
      const arabicaData = updateHighlightStatus(arabicaFilteredData, arabicaRef?.current)

      if (!accordianPopUpRef.current && (isWorkBookAvailable || isPlatinumUser) && workBookComponentRef?.current) {
        workBookComponentRef.current.filterWorkBookDataResponse(robustaData, arabicaData, currencyList)
      } else {
        robustaRef.current = robustaData
        arabicaRef.current = arabicaData
        lastMessageReceivedAtRef.current = Date.now()
        dispatch({ payload: { robustaData, arabicaData, lastMessageReceivedAt: Date.now() } })
      }
    }
  }

  const resetFlickeringEffect = () => {
    const updateHighlightStatus = (currentData) => currentData?.map((item) => ({ ...item, isHighlightRow: '' }))

    const robustaData = updateHighlightStatus(robustaRef?.current)
    const arabicaData = updateHighlightStatus(arabicaRef?.current)

    robustaRef.current = robustaData
    arabicaRef.current = arabicaData

    dispatch({ payload: { robustaData, arabicaData } })
  }

  const handleSelectContractDropdown = (e) => {
    const workBookType = parseInt(e.target.value, 10)
    setSelectedWorkBookType(workBookType)
    setSearchContractList(workBookType === 1 ? searchContractListForRobusta : searchContractListForArabica)
    setSelectedContract({})
  }

  const addWorkBookRowToRespectiveTable = async () => {
    if (seletectedWorkBookType === 3 || seletectedWorkBookType === 4 || selectedContract?.contractName) {
      workBookComponentRef.current.addWorkBookRowToRespectiveTable()
    }
  }

  const calculateTerminalDifference = (terminal) => {
    const item = terminal || handleSelectedTerminal
    const isRobusta = item?.idMarket == 1
    let targetedIndex = null
    let actualData = isRobusta ? robustaRef?.current : arabicaRef?.current
    let selectedTerminal = actualData?.find((ele, index) => {
      if (ele?.contractName == item?.contractName) {
        targetedIndex = index
        return ele
      }
    })
    if (item.optionExpiry !== 'DD-MMM-YYYY') {
      if (selectedTerminal) {
        let arrayList = []
        setAccordianPopupData(selectedTerminal)
        const { contractName, lastChng, chng } = selectedTerminal
        for (let i = 1; i < actualData.length - targetedIndex; i++) {
          let object = {
            parentTerminal: contractName,
            parentLastChng: lastChng,
            parentLastChngColor: chng >= 0 ? 'positive_green' : 'negative_red',
            childTerminal: actualData[targetedIndex + i]?.contractName,
            childTerminalChng: actualData[targetedIndex + i]?.lastChng,
            childLastChngColor: actualData[targetedIndex + i]?.chng >= 0 ? 'positive_green' : 'negative_red',
            difference: actualData[targetedIndex + i]?.lastChng - lastChng,
            differenceColor: actualData[targetedIndex + i]?.lastChng - lastChng >= 0 ? 'positive_green' : 'negative_red'
          }
          arrayList.push(object)
        }

        setAccordianPopupListData(arrayList)
      }
    }
  }

  const handleSelectContract = (terminal) => {
    if (terminal.optionExpiry !== 'DD-MMM-YYYY') {
      trackEvent(USER_EVENTS.COFFEE_QUOTES_CONTRACT) // user-analytics
      calculateTerminalDifference(terminal)
      setHandleSelectedTerminal(terminal)
      accordianPopUpRef.current = true
      dispatch({ payload: { accordianPopUp: true } })
    }
  }

  const handleCloseAccordianModal = () => {
    setHandleSelectedTerminal({})
    setAccordianPopupListData([])

    accordianPopUpRef.current = false
    dispatch({ payload: { accordianPopUp: false } })
  }

  const readMoreNews = (item) => {
    const { newsLock, id } = item
    if (!newsLock) {
      setLocalWithLatestNewsReadNotification(id)
      params.set('newsId', id)

      history.push({
        search: params.toString(),
        state: { pageRef: 'yes' },
        pathname: RouteStrings.opennewsnotification
      })
    } else history.push(RouteStrings.subscription)
  }

  const guestReadMoreNews = (item) => {
    const { showFullfreeNews, id } = item
    if (showFullfreeNews === true) {
      setLocalWithLatestNewsReadNotification(id)
      params.set('newsId', id)

      history.push({
        search: params.toString(),
        state: { pageRef: 'yes' },
        pathname: ROUTE_STRINGS.guestNewsFeed
      })
    } else {
      redirectForAuthentication(item)
    }
  }

  const handleMenuClick = () => {
    history.push(ROUTE_STRINGS.aboutUs)
  }

  const redirectForAuthentication = (item) => {
    const path = userLoginStatus ? ROUTE_STRINGS.createAccount : ROUTE_STRINGS.login
    history.push({
      pathname: path,
      state: {
        encryptedId: item.encryptedId,
        newsForSubscription: item.newsForSubscription,
        newsId: item.id,
        forGuestUser: true
      }
    })
  }

  const robustaAndArabicaTerminalTableHeaderTemplate = (contractType) => (
    <tr className="table_head" data-testid="coffee-quotes-table-head">
      <td className="contract_name" data-testid="contract-name-container">
        <img className="country-flag-icon" src={`https://coffeeweb.s3.ap-south-1.amazonaws.com/Masters/Flags/${contractType === 'robusta' ? 'GBR' : 'USA'}.svg`} alt="Flag" title="contract-flag" />
        {contractType === 'robusta' ? <>{window.innerWidth <= 1024 ? 'Robusta' : t('ROBUSTA_CONTRACTS')}</> : <>{window.innerWidth <= 1024 ? 'Arabica' : t('ARABICA_CONTRACTS')}</>}
      </td>
      <td className="pre-close">{t('PRE_CLOSE')}</td>
      <td className="last">{t('LAST')}</td>
      <td className="chng-cell">{t('CHG')}</td>
      <td className="percentage-value">%</td>
      <td className="volume">{t('VOL')}</td>
      <td className="open-interest">{t('OPEN_INT')}</td>
      <td className="high">{t('HIGH')}</td>
      <td className="net-high">{t('NET_HIGH')}</td>
      <td className="low">{t('LOW')}</td>
      <td className="net-low">{t('NET_LOW')}</td>
      <td className="open">{t('OPEN')}</td>
      <td className="bid">{t('BID')}</td>
      <td className="b-size">{t('BSIZE')}</td>
      <td className="ask">{t('ASK')}</td>
      <td className="a-size">{t('ASIZE')}</td>
      <td className="option-expiry">{window.innerWidth > 1024 ? t('OPTION_EXPIRY') : 'Opt Exp'}</td>
      <td className="first-notice-day">{t('FIRST_NOTICE_DAY')}</td>
      <td></td>
    </tr>
  )

  const { buttonText, infoMessage, className, navigationPath } = getButtonAndInfo()

  return (
    <>
      <MetaTagsComponent title={t('COFFEE_QUOTES_TITLE')} description={t('COFFEE_QUOTES_DESCRIPTION')} keywords={t('COFFEE_QUOTES_KEYWORDS')} url="https://coffeeweb.com/" h1Content={t('COFFEE_QUOTES_H1_CONTENT')} />
      <div className="coffee_quotes_screen" data-testid="coffee-quotes-container">
        {accordianPopUpRef?.current && <AccordianPopUp item={accordianPopupData} accordianPopupListData={accordianPopupListData} robustaData={robustaRef?.current} arabicaData={arabicaRef?.current} handleCloseAccordianModal={handleCloseAccordianModal} setLoading={setLoading} testId={'coffee-quotes-accordian-popup'} />}
        <div className="coffee_quotes_screen_header" data-testid="coffee-quotes-header">
          <div className="time_main_div_for_large_screen" data-testid="coffee-quotes-data-and-time-container">
            <div className="time_sub_div time" data-testid="coffee-quotes-data-container">
              {dateFormatBasedOnUser()}
            </div>
            <div className="time_sub_div" data-testid="coffee-quotes-time-container">
              <TimerPicker testId="time-picker-web-view" />
            </div>
          </div>
          <div className="time_main_div_for_mobile_screen" data-testid="coffee-quotes-date-and-time-container-mobile-view">
            <div className="time_sub_div" data-testid="date-container-mobile-view">
              <div>{t('DATE')}</div>
              <div className="time_colon">:</div>
              <div data-testid="date-container">{dateFormatBasedOnUser()}</div>
            </div>
            <div className="time_sub_div" data-testid="time-container-mobile-view">
              <div>{t('TIME')}</div>
              <div className="time_colon">:</div>
              <TimerPicker testId="time-picker-mobile-view" />
            </div>
            <div className="about-us-nav-mobile">
              <img src="https://coffeeweb.s3.ap-south-1.amazonaws.com/Dev-AboutCoffeeWeb.png" alt="" className="about-us-nav-icon" onClick={() => handleMenuClick('aboutCoffeeWeb')} />
            </div>
          </div>

          {/* {marquee.length > 0 && ( */}
          <div
            className={`for_trending_news ${!marquee.length ? 'trending-news-absent' : ''}`}
            style={{
              width: trendingNewsStyle.width
            }}
            data-testid="coffee-quotes-marquee-main-container"
          >
            <div className="labaling">{marquee.length ? `${t('TRENDING_NEWS')} :` : ''}</div>{' '}
            <Marquee pauseOnHover="true" speed="27" className="marquee_main_div">
              <>
                {marquee?.map((item, index) => (
                  <React.Fragment key={index}>
                    <div className="marquee_tag" onClick={() => (userDetails ? readMoreNews(item) : guestReadMoreNews(item))} data-testid="marquee-tag-container">
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <div className="bullet_dot" data-testid="bullet-dot-container"></div>
                        <div style={{ color: item?.trendingNewsColour }} className={`${item?.trendingNewsColour === '#000000' ? 'coffeequotes-trending-news-color' : ''}`} data-testid="marquee-tag-subject-container">
                          <span dangerouslySetInnerHTML={{ __html: item?.newsSubject || '' }} />
                        </div>
                      </div>
                    </div>
                  </React.Fragment>
                ))}
              </>
            </Marquee>
          </div>
          {/* )} */}
          {isWebView && (
            <div className="about-us-nav-web">
              <img src="https://coffeeweb.s3.ap-south-1.amazonaws.com/Dev-AboutCoffeeWeb.png" alt="" className="about-us-nav-icon" onClick={() => handleMenuClick('aboutCoffeeWeb')} />
            </div>
          )}
        </div>
        <div className="coffee_quotes_screen_body" data-testid="coffee-quotes-table-container">
          {/* Robusta and arabica table */}
          {isWebView && (
            <table className="robusta_and_arabica_table" data-testid="coffee-quotes-table-for-robusta-and-arabica">
              <tbody className="robusta_table" data-testid="table-body-for-robusta">
                {robustaAndArabicaTerminalTableHeaderTemplate('robusta')}
                {robustaRef?.current?.map((item, index) => (
                  <AccordianData handleSelectContract={handleSelectContract} item={item} keyID={index} key={index} testId={'coffee-quotes-robusta-accordian-data'} />
                ))}
              </tbody>
              <tbody className="arabica_table" data-testid="table-body-for-arabica">
                {robustaAndArabicaTerminalTableHeaderTemplate('arabica')}
                {arabicaRef?.current?.map((item, index) => (
                  <AccordianData handleSelectContract={handleSelectContract} item={item} keyID={index} key={index} testId={'coffee-quotes-arabica-accordian-data'} />
                ))}
              </tbody>
            </table>
          )}
          {isMobileView && (
            <div className="accordian-for-mobile-wrapper">
              <AccordianForMobile data={robustaRef?.current} labeling={t('ROBUSTA')} idMarket={1} data-testid="accordion-for-mobile" />
              <AccordianForMobile data={arabicaRef?.current} labeling={t('ARABICA')} idMarket={2} data-testid="accordion-for-mobile" />
              {/* Kept it for future reference */}

              {/* <div className="coffeeweb-logo-card">
                <CreateAccountInfoModal showLogo={false} customStyling={{ borderRadius: '20px', borderWidth: 'thick' }} showCreateAccountButton={isWebView} buttonText={t(`${buttonText}`)} infoMessage={isWebView ? t(`${infoMessage}`) : t('FOR_A_SMOOTHER_AND_MORE_COMFORTABLE_EXPERIENCE_DOWNLOAD_THE_MOBILE_APP')} className={className} navigationPath={navigationPath} state={{ subscriptionId: 3 }} />
              </div> */}
            </div>
          )}
          <div className="coffeequotes-table-divider">{/* this div should be empty for divider */}</div>
          {/* {isPlatinumUser || isWorkBookAvailable ? ( */}
          <>
            {/* {isWebView && ( */}
            <WorkBook
              ref={workBookComponentRef}
              dispatch={dispatch}
              robustaRef={robustaRef}
              arabicaRef={arabicaRef}
              volumeDataRef={volumeDataRef}
              certifiedLotsDataRef={certifiedLotsDataRef}
              workbookRobustaDataRef={workbookRobustaDataRef}
              workbookArabicaDataRef={workbookArabicaDataRef}
              fxCurrencyListRef={fxCurrencyListRef}
              setSearchContractList={setSearchContractList}
              setSearchContractListForRobusta={setSearchContractListForRobusta}
              setSearchContractListForArabica={setSearchContractListForArabica}
              selectedContract={selectedContract}
              seletectedWorkBookType={seletectedWorkBookType}
              showError={showError}
              showSuccess={showSuccess}
              showConfirmation={showConfirmation}
              lastMessageReceivedAtRef={lastMessageReceivedAtRef}
              selectedCurrencyRobustaRef={selectedCurrencyRobustaRef}
              selectedCurrencyArabicaRef={selectedCurrencyArabicaRef}
              handleWorkbookDropDown={handleWorkbookDropDown}
              handleSelectContractDropdown={handleSelectContractDropdown}
              marquee={marquee}
              searchContractList={searchContractList}
              setSelectedContract={setSelectedContract}
              testId={'coffee-quotes-work-book'}
            />
            {/* )} */}
          </>
          {/* ) : (
            <>
              <div className="creat_account_guest_info_modal">
                <CreateAccountInfoModal buttonText={t(`${buttonText}`)} infoMessage={t(`${infoMessage}`)} className={className} navigationPath={navigationPath} testId="coffee-quotes-create-account" state={{ subscriptionId: 3 }} />
              </div>
            </>
          )} */}
        </div>
      </div>
      <Toast ref={coffeequoteDataErrorToast} position="bottom-right" />
      <DraggableChatButton isChatPanelOpen={isChatPanelOpen} setIsChatPanelOpen={setIsChatPanelOpen} onUnreadCountsChange={handleUnreadCountsChange} unreadCountRefreshRef={unreadCountRefreshRef} />
      <CoffeeChats isChatPanelOpen={isChatPanelOpen} setIsChatPanelOpen={setIsChatPanelOpen} personalUnreadCount={personalUnreadCount} communityUnreadCount={communityUnreadCount} onUnreadCountRefresh={() => unreadCountRefreshRef.current?.()} />
    </>
  )
}

export default ErrorMessageModal(CoffeeQuotes)
